import React from 'react';

import styles from './CartThreshold.module.scss';

function CartThreshold({
  thresholdMessages,
}: {
  thresholdMessages: string[];
}): JSX.Element {
  return (
    <>
      {thresholdMessages.map(message => (
        <p
          className={styles.message}
          dangerouslySetInnerHTML={{ __html: message }}
          key={message}
        />
      ))}
    </>
  );
}

export default CartThreshold;
